import script from "./GodApeQuestStartModal.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestStartModal.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestStartModal.vue?vue&type=style&index=0&id=24733f84&lang=scss"

const __exports__ = script;

export default __exports__